let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i5I3w")).then(() => parcelRequire('2XJ8t'));